declare global {
  interface Window {
    smartlook: any;
  }
}

const initSmartlook = (apiKey: string, users: string, loginName: string) => {
  if (!loginName || !apiKey) return;

  if (users != null) {
    const usersArray = users.split(";");
    const foundUser = usersArray.some((user) => user.toLowerCase().trim() === loginName.toLowerCase().trim());

    if (!foundUser) return;
  }

  window.smartlook ||
    (function (d) {
      var o: any = (window.smartlook = function () {
          o.api.push(arguments);
        }),
        h = d.getElementsByTagName("head")[0];
      var c = d.createElement("script");
      o.api = new Array();
      c.async = true;
      c.type = "text/javascript";
      c.charset = "utf-8";
      c.src = "https://rec.smartlook.com/recorder.js";
      h.appendChild(c);
    })(document);
  window.smartlook("init", apiKey);

  var consentText = "Consent text";
  var clientDecision = true;

  window.smartlook("consentAPI", clientDecision ? consentText : false);
  window.smartlook("consentForms", clientDecision ? consentText : false);
  window.smartlook("consentIP", clientDecision ? consentText : false);

  window.smartlook("identify", loginName);
};

export default initSmartlook;
